import React, { FC } from "react";
import Recommended from "components/blog/recommended";
import BlogEntryTeaser from "components/blog/blogentryteaser";
import { renderMarkdown } from "lib/markdownrenderer";
import { BlogPostType } from "components/blog/BlogTypes";
import { DynamicContentBlock } from "components/information-lister-pages/DynamicContentBlock";

import Styles from "./global.scss";

const fixYoutube = (html: string) =>
    html.replace(/(<iframe.*src=".*youtube.*><\/iframe>)/gi, '<div class="videoWrapper">$1</div>');

type Props = {
    post: BlogPostType;
    whatIsPosts: BlogPostType[];
    recommendedPosts: BlogPostType[];
};

const BlogPost: FC<Props> = (props) => {
    const { post, whatIsPosts, recommendedPosts } = props;
    const styles = Styles;
    const renderedText = fixYoutube(renderMarkdown(post.content));

    return (
        <div className="blog-post">
            <style jsx>{styles}</style>
            {/* Hero */}
            <BlogEntryTeaser showSocial layout="hero" includeLink={false} post={post} />

            {/* Content area */}
            <div
                className="content-area"
                dangerouslySetInnerHTML={{
                    __html: renderedText
                }}
            />

            <div>
                {post.dynamicContentList &&
                    post.dynamicContentList.length > 0 &&
                    post.dynamicContentList.map((block) => (
                        <DynamicContentBlock
                            key={block.id}
                            _type={block.type}
                            title={block.name}
                            {...block}
                        />
                    ))}
            </div>

            <div className="main-items">
                {post.recommended &&
                    post.recommended.map((p) => <BlogEntryTeaser key={p.id} post={p} />)}
            </div>

            {/* Recommended */}
            {whatIsPosts && recommendedPosts && (
                <Recommended whatIsPosts={whatIsPosts} recommendedPosts={recommendedPosts} />
            )}
        </div>
    );
};

export default BlogPost;
